import { NextPage, GetServerSidePropsResult } from "next";
import styles from "./index.module.scss";
import Image from "next/image";
import Fetch from "../../utils/request";
import { convertToI18 } from "../../utils/types";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { ParsedUrlQuery } from "querystring";
import { Breadcrumb } from "antd";
import { ServerResponse } from "http";
import { wrapCDN } from "@/utils/cdn";
import * as React from "react";
import { getCookie } from "cookies-next";
import { formatTime2london } from "@/utils/format";
import Item from "@/components/SeoItem/Item";
import NoDataError from "@/components/noDataError";
import { useWidth } from "@/utils/resize";
import { rangeNumID } from "@/utils/count";
import Banner from "@@/detail/pc/banner";
import MBanner from "@@/detail/moblie/banner";
import Rank from "@@/detail/pc/rank";
import MRank from "@@/detail/moblie/rank";
const error =
    "data:image/jpeg;base64,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";
const locales = ["en"];
const fetch = new Fetch();
const BaseUrl = process.env.portalApiUrl;
const login = process.env.loginUrl;
const tt = process.env.portalUrl;

const GspPage: NextPage<{
    locale: string;
    locales: string[];
    similarVideos: string[];
    moreVideos: string[];
    videoDetail: {
        authorId: string;
        id: string;
        authorUniqueId: string;
        authorNickname: string;
        authorFollowerCount: number;
        authorVideoCount: string;
        diggCount: number;
        commentCount: number;
        music: any;
        tagList: any[];
        shareCount: number;
        playCount: number;
        videoCount: number;
        originCoverPrivatization: string;
        originCover: string;
        desc: string;
        createTime: number;
        musicTitle: string;
        lastTimeStamp: number;
        lastTime: string;
        videoDuration: number;
        belongingCountry: string;
        authorAvatarLargerPrivatization: string;
        interactionRate: number;
        increasePlayCount: number;
        increaseDiggCount: number;
        increaseShareCount: number;
        increaseCommentCount: number;
        increaseVideoCount: number;
        increaseInteractionRate: number;
        latestVideos: string[];
    };
    rankList: any[];
}> = (props) => {
    const { t } = useTranslation("report");
    const router = useRouter();
    const { videoDetail, rankList } = props;

    const num = rangeNumID(videoDetail?.id);
    const seoTitleArr = [
        `${videoDetail.authorNickname} TikTok Videos | Shoplus Analytics`,
        `${videoDetail.authorNickname} tiktok most popular videos | Shoplus`,
        `${videoDetail.authorNickname} - Top TikTok Videos | Shoplus`,
        `${videoDetail.authorNickname} TikTok Video Analytics | Shoplus`,
    ];
    const seoKeyword = [
        "TikTok Video Analytics",
        "popular tiktok videos",
        "TikTok Videos",
        "Best Tiktok Video",
        "Top TikTok Videos",
    ];
    const { locales, locale } = router;
    const latestVideos = (videoDetail.latestVideos || []).map((item) => {
        // @ts-ignore
        item.avatarLargerPrivatization =
            videoDetail.authorAvatarLargerPrivatization;
        return item;
    });
    // @ts-ignore
    // const time = formatTime2london(videoDetail.createTime * 1000, "YYYY-MM-DD hh:mm:ss")
    const time = new Date(videoDetail.createTime * 1000)
        .toUTCString()
        .split("GMT")[0];
    const open = () => {
        window.open(
            `https://www.tiktok.com//@${videoDetail.authorUniqueId}/video/${videoDetail.id}`,
            "_blank"
        );
    };
    const isAuth = getCookie("authorized-token") ? true : false;
    const { width, display } = useWidth();
    const goDetail = () => {
        if (width > 1024) {
            if (isAuth) {
                // window.open(
                //   tt +
                //     `/videoDetail?id=${videoDetail.id}&lastTime=${formatTime2london(
                //       videoDetail.lastTimeStamp as number
                //     )}`,
                //   "_blank"
                // );
                window.open(
                    tt +
                        `/material/video/${
                            videoDetail.id
                        }?name=soaring&lastTime=${formatTime2london(
                            videoDetail.lastTimeStamp as number
                        )}`,
                    "_blank"
                );
            } else {
                // window.open(login + "?fromPath=" + window.location.href);
                window.open(
                    login +
                        "?fromPath=" +
                        tt +
                        `/material/video/${
                            videoDetail.id
                        }?name=soaring&lastTime=${formatTime2london(
                            videoDetail.lastTimeStamp as number
                        )}`,
                    "_blank"
                );
            }
        } else {
            if (isAuth) {
                window.open(
                    process.env.mobileUrl +
                        `/material/video/${
                            videoDetail.id
                        }?name=soaring&lastTime=${formatTime2london(
                            videoDetail.lastTimeStamp as number
                        )}`,
                    "_blank"
                );
            } else {
                window.open(process.env.loginMobileUrl, "_blank");
            }
        }
    };

    const goLogin = () => {
        if (width > 1024) {
            if (isAuth) {
                // window.open(tt + "/videos/soaring", "_blank");
                window.open(tt + "/video/list?name=soaring", "_blank");
            } else {
                window.open(login + "?fromPath=" + window.location.href);
            }
        } else {
            if (isAuth) {
                window.open(
                    process.env.mobileUrl +
                        "/list?name=Videos&subname=Thriving",
                    "_blank"
                );
            } else {
                window.open(process.env.loginMobileUrl, "_blank");
            }
        }
    };
    const handleToDownload = () => {
        window.open(
            "https://chrome.google.com/webstore/detail/tikmeta-insight%EF%BC%9Atiktok-an/cpekabdeobhejggemedbfkahjafpfbic?hl=zh-CN",
            "_blank"
        );
    };

    if (!videoDetail.id) {
        return (
            <div className={styles["report"]}>
                <NoDataError msg="No Data" hrefStr={"videos"}>
                    <div
                        className="text-[24px] font-[600] text-[#2E384E] px-[15px]"
                        style={{
                            fontFamily: "PingFangSC-Semibold,PingFangSC",
                        }}
                    >
                        {locale === "en" ? "recommend " : "推荐 "}
                    </div>
                    <div className="mt-[24px] itemBox grid grid-cols-5 gap-[30px] mt-[30px] pb-[78px] lg1024:grid-cols-2 lg1024:gap-[9px] lg1024:px-[15px] lg1024:!mt-[4px] lg1024:!pb-[20px]">
                        {props.moreVideos ||
                            [].map((item: any, index: any) => (
                                <a key={index} target="blank">
                                    <Item
                                        item={item}
                                        isLast={false}
                                        type={"isVideoDetail"}
                                    ></Item>
                                </a>
                            ))}
                    </div>
                </NoDataError>
            </div>
        );
    }
    const remakeDesc = () => {
        let str = videoDetail.desc;
        if (str.length) {
            if (videoDetail?.tagList) {
                for (let i = 0; i <= videoDetail?.tagList.length; i++) {
                    let reg = new RegExp(`#${videoDetail?.tagList[i]?.title}`);
                    str = str.replace(reg, "");
                }
            }
           
        }
        return str;
    };
    return (
        <div
            className={styles["report"]}
            style={{ visibility: !display ? "hidden" : "visible" }}
        >
            <div className="w-full h-[70px] !bg-[#fff]"></div>
            <Head>
            <meta name="robots" content="noindex"></meta>
                {locale === "en" ? (
                    <link
                        rel="canonical"
                        href={`https://www.shoplue.net/tiktok-videos/${videoDetail.id}`}
                    />
                ) : null}

                {locale !== "en" ? (
                    <link
                        key={locale}
                        rel="alternate"
                        hrefLang={locale}
                        href={`https://www.shoplue.net/tiktok-videos/${
                            videoDetail.id
                        }${locale === "en" ? "" : "" + locale}`}
                    />
                ) : null}
                <title>{seoTitleArr[num] + ""}</title>
                <meta name="keywords" content={seoKeyword[num]} />
                <meta
                    name="description"
                    content={`This is a tiktok video published by ${videoDetail?.authorNickname}.,More than ${videoDetail?.diggCount} likes,${videoDetail?.commentCount} comments and ${videoDetail?.shareCount} shares,View specific video analysis and similar videos.`}
                />
            </Head>
            {width > 1024 ? <Banner></Banner> : <MBanner></MBanner>}
            <div
                className={`${styles["report-main"]} maxlg1920:w-[1400px] minlg1920:w-[1400px]  maxlg1560:w-[1240px] maxlg1400:w-[1160px] lg1024:w-[1100px] lgbetween:w-[1080px] lg1024:w-full dvmobile`}
            >
                <div className={styles["title"]}>
                    <div className="my-[30px] lg1024:px-[15px] lg1024:!mt-0">
                        <Breadcrumb>
                            <Breadcrumb.Item
                                href={`${process.env.publicUrl}/`}
                            >
                                {locale === "en" ? "Home" : "首页"}
                            </Breadcrumb.Item>
                            <Breadcrumb.Item
                                href={`${process.env.publicUrl}/videos/1`}
                            >
                                {locale === "en"
                                    ? "Videos Ranking"
                                    : "视频目录"}
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                {locale === "en" ? "Video Details" : "视频详情"}
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <p className="lg1024:px-[15px]">
                        {t("info", {
                            authorUniqueId: videoDetail.authorNickname,
                            diggCount: convertToI18(videoDetail.diggCount),
                            commentCount: convertToI18(
                                videoDetail.commentCount
                            ),
                            shareCount: convertToI18(videoDetail.shareCount),
                        })}
                    </p>
                </div>
                <div
                    className={
                        styles["content"] +
                        " lg1024:!px-0 w-full lg1024:!flex-col"
                    }
                >
                    {width > 1024 ? (
                        <div className={styles["left"]}>
                            <p>
                                {remakeDesc()}
                                {videoDetail.tagList
                                    ? videoDetail.tagList.map((el, index) => {
                                          return el.id ? (
                                              <a
                                                  className="text-[#191919] ml-[13px] underline visited:text-[#191919] underline  hover:text-[#ff667a]"
                                                  key={index}
                                                  href={
                                                      el.id
                                                          ? `${
                                                                router.locale ==
                                                                "en"
                                                                    ? ""
                                                                    : ""
                                                            }/tiktok-tags/${
                                                                el.id
                                                            }`
                                                          : ""
                                                  }
                                              >
                                                  #{el.title}
                                              </a>
                                          ) : (
                                              <span> #{el.title}</span>
                                          );
                                      })
                                    : null}
                                {videoDetail.music ? (
                                    <a
                                        className="text-[#191919] ml-[20px] visited:text-[#191919] hover:text-[#ff667a]"
                                        href={`${
                                            router.locale == "en" ? "" : ""
                                        }/tiktok-music/${
                                            videoDetail?.music?.id
                                        }`}
                                    >
                                        <i className="iconfont icon-yinle1 mr-[10px]"></i>
                                        <span>{videoDetail.music?.title}</span>
                                    </a>
                                ) : null}
                            </p>
                            <span>
                                {t("Duration")}: {videoDetail.videoDuration} s
                            </span>
                            <span>
                                {t("Posted")} : {time}
                            </span>
                            <div className="flex items-center mt-[58px]">
                                <a
                                    href={`${
                                        router.locale == "en" ? "" : ""
                                    }/tiktok-influencers/${
                                        videoDetail?.authorUniqueId
                                    }-${videoDetail?.authorId}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="mr-[66px]"
                                >
                                    <div className={styles["avt"]}>
                                        <img
                                            src={
                                                videoDetail.authorAvatarLargerPrivatization
                                                    ? wrapCDN(
                                                          videoDetail.authorAvatarLargerPrivatization,
                                                          100
                                                      )
                                                    : error
                                            }
                                        />
                                        <div className={styles["info"]}>
                                            <p style={{ marginBottom: 8 }}>
                                                {videoDetail.authorNickname}
                                            </p>
                                            <p
                                                style={{
                                                    fontSize: 12,
                                                    fontWeight: 400,
                                                }}
                                            >
                                                <span>
                                                    @
                                                    {videoDetail.authorUniqueId}
                                                </span>
                                                <strong>
                                                    {convertToI18(
                                                        videoDetail.authorFollowerCount
                                                    )}
                                                </strong>
                                                <span>{t("Followers")}</span>
                                                <strong>
                                                    {
                                                        videoDetail.authorVideoCount
                                                    }
                                                </strong>
                                                <span>{t("Videos")}</span>
                                            </p>
                                        </div>
                                    </div>
                                </a>
                                {/* <Rank type={"video"} rankList={rankList}></Rank> */}
                            </div>

                            <div className={styles["data"]}>
                                <div className={styles["item"]}>
                                    <p>{t("Views")}</p>
                                    <span>
                                        {convertToI18(videoDetail.playCount)}
                                    </span>
                                    <p>
                                        {t("Daily")}
                                        <span className={styles["up"]}>
                                            {videoDetail.increasePlayCount === 0
                                                ? "-"
                                                : `+
                                    ${convertToI18(
                                        videoDetail.increasePlayCount
                                    )}`}
                                        </span>
                                    </p>
                                </div>
                                <div className={styles["item"]}>
                                    <p>{t("Likes")}</p>
                                    <span>
                                        {convertToI18(videoDetail.diggCount)}
                                    </span>
                                    <p>
                                        {t("Daily")}
                                        <span className={styles["up"]}>
                                            {videoDetail.increaseDiggCount === 0
                                                ? "-"
                                                : `+
                                    ${convertToI18(
                                        videoDetail.increaseDiggCount
                                    )}`}
                                        </span>
                                    </p>
                                </div>
                                <div className={styles["item"]}>
                                    <p>{t("Comments")}</p>
                                    <span>
                                        {convertToI18(videoDetail.commentCount)}
                                    </span>
                                    <p>
                                        {t("Daily")}
                                        <span className={styles["up"]}>
                                            {videoDetail.increaseCommentCount ===
                                            0
                                                ? "-"
                                                : `+
                                    ${convertToI18(
                                        videoDetail.increaseCommentCount
                                    )}`}
                                        </span>
                                    </p>
                                </div>
                                <div className={styles["item"]}>
                                    <p>{t("Shares")}</p>
                                    <span>
                                        {convertToI18(videoDetail.shareCount)}
                                    </span>
                                    <p>
                                        {t("Daily")}
                                        <span className={styles["up"]}>
                                            {videoDetail.increaseShareCount ===
                                            0
                                                ? "-"
                                                : `+
                                    ${convertToI18(
                                        videoDetail.increaseShareCount
                                    )}`}
                                        </span>
                                    </p>
                                </div>
                                <div className={styles["item"]}>
                                    <p>{t("ER")}</p>
                                    <span>
                                        {(
                                            videoDetail.interactionRate * 100
                                        ).toFixed(2)}
                                        %
                                    </span>
                                    <p>
                                        {t("Daily")}
                                        {videoDetail.increaseInteractionRate >
                                        0 ? (
                                            <span className={styles["up"]}>
                                                +
                                                {(
                                                    videoDetail.increaseInteractionRate *
                                                    100
                                                ).toFixed(2)}
                                                %
                                            </span>
                                        ) : videoDetail.increaseInteractionRate ===
                                          0 ? (
                                            <span className={styles["up"]}>
                                                -
                                            </span>
                                        ) : (
                                            <span className={styles["down"]}>
                                                {(
                                                    videoDetail.increaseInteractionRate *
                                                    100
                                                ).toFixed(2)}
                                                %
                                            </span>
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {width > 1024 ? (
                        <div className={styles["right"]}>
                            <a
                                rel="nofollow noreferrer"
                                className={styles["img"]}
                                target="_blank"
                                href={`https://www.tiktok.com/@${videoDetail.authorUniqueId}/video/${videoDetail.id}`}
                            >
                                <div className={`${styles.icon}`}>
                                    <svg
                                        viewBox="0 0 1024 1024"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        p-id="4749"
                                        width="17"
                                        height="20"
                                    >
                                        <path
                                            d="M870.186667 466.346667l-618.666667-373.333334A53.333333 53.333333 0 0 0 170.666667 138.752V885.333333a53.205333 53.205333 0 0 0 80.896 45.653334l618.666666-373.290667a53.333333 53.333333 0 0 0 0-91.306667z"
                                            p-id="4750"
                                            fill="#ffffff"
                                        ></path>
                                    </svg>
                                </div>
                                <img
                                    src={wrapCDN(
                                        videoDetail.originCoverPrivatization,
                                        300
                                    )}
                                />
                            </a>
                            <div className={styles["btn"]}>
                                <a
                                    onClick={() => {
                                        goDetail();
                                    }}
                                >
                                    <svg
                                        width="16px"
                                        height="16px"
                                        viewBox="0 0 16 16"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <title>下载</title>
                                        <g
                                            id="页面-1"
                                            stroke="none"
                                            strokeWidth="1"
                                            fill="none"
                                            fillRule="evenodd"
                                        >
                                            <g
                                                id="视频详情"
                                                transform="translate(-1344.000000, -665.000000)"
                                                fill="#000000"
                                                fillRule="nonzero"
                                            >
                                                <g
                                                    id="编组-9"
                                                    transform="translate(1326.000000, 650.000000)"
                                                >
                                                    <g
                                                        id="下载"
                                                        transform="translate(18.000000, 15.000000)"
                                                    >
                                                        <rect
                                                            id="矩形"
                                                            opacity="0"
                                                            x="0"
                                                            y="0"
                                                            width="16"
                                                            height="16"
                                                        ></rect>
                                                        <path
                                                            d="M13.7107813,5.9604375 L10.4474688,5.9604375 L10.4474688,1.06548438 L5.5525,1.06548438 L5.5525,5.9604375 L2.28921875,5.9604375 L7.99998437,11.6712188 L13.7107813,5.9604375 L13.7107813,5.9604375 Z M2.28921875,13.3028594 L2.28921875,14.9345 L13.7107813,14.9345 L13.7107813,13.3028594 L2.28921875,13.3028594 Z"
                                                            id="形状"
                                                        ></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    {t("Download")}
                                </a>
                                <a
                                    onClick={() => {
                                        goDetail();
                                    }}
                                >
                                    <svg
                                        width="16px"
                                        height="16px"
                                        viewBox="0 0 16 16"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <title>收藏</title>
                                        <g
                                            id="页面-1"
                                            stroke="none"
                                            strokeWidth="1"
                                            fill="none"
                                            fillRule="evenodd"
                                        >
                                            <g
                                                id="视频详情"
                                                transform="translate(-1494.000000, -664.000000)"
                                                fill="#000000"
                                                fillRule="nonzero"
                                            >
                                                <g
                                                    id="编组-10"
                                                    transform="translate(1471.000000, 650.000000)"
                                                >
                                                    <g
                                                        id="收藏"
                                                        transform="translate(23.000000, 14.000000)"
                                                    >
                                                        <rect
                                                            id="矩形"
                                                            opacity="0"
                                                            x="0"
                                                            y="0"
                                                            width="16"
                                                            height="16"
                                                        ></rect>
                                                        <path
                                                            d="M8.6588,2.1392 L9.834,4.5412 C9.97243266,4.82517717 10.2419202,5.02269166 10.5544,5.0692 L13.1792,5.4536 C13.9648,5.5692 14.278,6.5428 13.7096,7.1024 L11.8096,8.972 C11.5836191,9.19528172 11.4810112,9.51490437 11.5348,9.828 L11.9832,12.4672 C12.1172,13.2576 11.2964,13.8596 10.594,13.4868 L8.246,12.2408 C7.96715042,12.0925322 7.63284958,12.0925322 7.354,12.2408 L5.006,13.4868 C4.3036,13.8596 3.4828,13.2576 3.6168,12.4672 L4.0652,9.8276 C4.11898876,9.51450437 4.01638093,9.19488172 3.7904,8.9716 L1.8904,7.1036 C1.322,6.5444 1.6352,5.5704 2.4208,5.4556 L5.0456,5.0708 C5.35807977,5.02429166 5.62756734,4.82677717 5.766,4.5428 L6.9424,2.1392 C7.2936,1.4204 8.3076,1.4204 8.6588,2.1392 Z"
                                                            id="路径"
                                                        ></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    {t("Favourite")}
                                </a>
                            </div>
                        </div>
                    ) : null}

                    {/* 手机端 */}
                    {width < 1024 ? (
                        <div>
                            <div className={styles["top"]}>
                                <div className="flex">
                                    <a
                                        rel="nofollow noreferrer"
                                        href={`https://www.tiktok.com/@${videoDetail.authorUniqueId}/video/${videoDetail.id}`}
                                        target="_blank"
                                    >
                                        <div className={styles["img"]}>
                                            <div className={`${styles.icon}`}>
                                                <svg
                                                    viewBox="0 0 1024 1024"
                                                    version="1.1"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    p-id="4749"
                                                    width="17"
                                                    height="20"
                                                >
                                                    <path
                                                        d="M870.186667 466.346667l-618.666667-373.333334A53.333333 53.333333 0 0 0 170.666667 138.752V885.333333a53.205333 53.205333 0 0 0 80.896 45.653334l618.666666-373.290667a53.333333 53.333333 0 0 0 0-91.306667z"
                                                        p-id="4750"
                                                        fill="#ffffff"
                                                    ></path>
                                                </svg>
                                            </div>
                                            <img
                                                src={wrapCDN(
                                                    videoDetail.originCoverPrivatization,
                                                    300
                                                )}
                                            />
                                        </div>
                                    </a>

                                    <div className="flex flex-col justify-center">
                                        {videoDetail.desc ? (
                                            <p
                                                style={{
                                                    fontFamily:
                                                        "PingFangSC-Semibold,PingFangSC",
                                                }}
                                                className="ml-[13px] ellipse-3 w-[228px] h-[79px] text-[18px] font-[600] text-[#191919] leading-[25px] mb-0"
                                            >
                                                {videoDetail.desc}
                                            </p>
                                        ) : null}

                                        <span
                                            className="mt-[7px] ml-[13px] text-[12px] font-[400] text-[#708096]"
                                            style={{
                                                fontFamily:
                                                    "PingFangSC-Regular,PingFangSC",
                                            }}
                                        >
                                            {t("Duration")}:{" "}
                                            {videoDetail.videoDuration} s
                                        </span>
                                        <span
                                            className="ml-[13px] text-[12px] font-[400] text-[#708096]"
                                            style={{
                                                fontFamily:
                                                    "PingFangSC-Regular,PingFangSC",
                                            }}
                                        >
                                            {t("Posted")} : {time}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="px-[15px] mb-[20px]">
                                <MRank
                                    type={"video"}
                                    rankList={rankList}
                                ></MRank>
                            </div> */}
                            <div className={styles["center"]}>
                                <a
                                    href={`${
                                        router.locale == "en" ? "" : ""
                                    }/tiktok-influencers/${
                                        videoDetail?.authorUniqueId
                                    }-${videoDetail?.authorId}`}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <div className={styles["avt"]}>
                                        <img
                                            src={
                                                videoDetail.authorAvatarLargerPrivatization
                                                    ? wrapCDN(
                                                          videoDetail.authorAvatarLargerPrivatization,
                                                          100
                                                      )
                                                    : error
                                            }
                                        />
                                        <div className={styles["info"]}>
                                            <p style={{ marginBottom: 4 }}>
                                                {videoDetail.authorNickname}
                                            </p>
                                            <p
                                                style={{
                                                    fontSize: 12,
                                                    fontWeight: 400,
                                                }}
                                            >
                                                <span>
                                                    @
                                                    {videoDetail.authorUniqueId}
                                                </span>
                                            </p>
                                            <p
                                                style={{
                                                    fontSize: 12,
                                                    fontWeight: 400,
                                                    marginTop: 10,
                                                }}
                                            >
                                                <span className="text-[14px] !pr-[2px]  !text-[#2E384E]">
                                                    {convertToI18(
                                                        videoDetail.authorFollowerCount
                                                    )}
                                                </span>
                                                <span>{t("Followers")}</span>
                                                <span className="text-[14px] !pr-[2px] !text-[#2E384E]">
                                                    {
                                                        videoDetail.authorVideoCount
                                                    }
                                                </span>
                                                <span>{t("Videos")}</span>
                                            </p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div
                                className={
                                    styles["bottom"] +
                                    " grid grid-cols-3 gap-[12px] px-[15px] pb-[24px] "
                                }
                            >
                                <div className={styles["item"]}>
                                    <p>{t("Views")}</p>
                                    <span>
                                        {convertToI18(videoDetail.playCount)}
                                    </span>
                                    <p>
                                        {t("Daily")}
                                        <span className={styles["up"]}>
                                            {videoDetail.increasePlayCount === 0
                                                ? "-"
                                                : `+
                                    ${convertToI18(
                                        videoDetail.increasePlayCount
                                    )}`}
                                        </span>
                                    </p>
                                </div>
                                <div className={styles["item"]}>
                                    <p>{t("Likes")}</p>
                                    <span>
                                        {convertToI18(videoDetail.diggCount)}
                                    </span>
                                    <p>
                                        {t("Daily")}
                                        <span className={styles["up"]}>
                                            {videoDetail.increaseDiggCount === 0
                                                ? "-"
                                                : `+
                                    ${convertToI18(
                                        videoDetail.increaseDiggCount
                                    )}`}
                                        </span>
                                    </p>
                                </div>
                                <div className={styles["item"]}>
                                    <p>{t("Comments")}</p>
                                    <span>
                                        {convertToI18(videoDetail.commentCount)}
                                    </span>
                                    <p>
                                        {t("Daily")}
                                        <span className={styles["up"]}>
                                            {videoDetail.increaseCommentCount ===
                                            0
                                                ? "-"
                                                : `+
                                    ${convertToI18(
                                        videoDetail.increaseCommentCount
                                    )}`}
                                        </span>
                                    </p>
                                </div>
                                <div className={styles["item"]}>
                                    <p>{t("Shares")}</p>
                                    <span>
                                        {convertToI18(videoDetail.shareCount)}
                                    </span>
                                    <p>
                                        {t("Daily")}
                                        <span className={styles["up"]}>
                                            {videoDetail.increaseShareCount ===
                                            0
                                                ? "-"
                                                : `+
                                    ${convertToI18(
                                        videoDetail.increaseShareCount
                                    )}`}
                                        </span>
                                    </p>
                                </div>
                                <div className={styles["item"]}>
                                    <p>{t("ER")}</p>
                                    <span>
                                        {(
                                            videoDetail.interactionRate * 100
                                        ).toFixed(2)}
                                        %
                                    </span>
                                    <p>
                                        {t("Daily")}
                                        {videoDetail.increaseInteractionRate >
                                        0 ? (
                                            <span className={styles["up"]}>
                                                +
                                                {videoDetail.increaseInteractionRate *
                                                    100}
                                                %
                                            </span>
                                        ) : videoDetail.increaseInteractionRate ===
                                          0 ? (
                                            <span className={styles["up"]}>
                                                -
                                            </span>
                                        ) : (
                                            <span className={styles["down"]}>
                                                {videoDetail.increaseInteractionRate *
                                                    100}
                                                %
                                            </span>
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className={styles["videos"] + " lg1024:!mt-[20px]"}>
                    <div className={styles["t"] + " lg1024:px-[15px]"}>
                        <p className="lg1024:!text-[16px]">{t("Latest")}</p>
                    </div>
                    <div
                        className="mt-[24px] itemBox grid grid-cols-5 gap-[30px] mt-[30px] pb-[78px]
                    lg1024:grid-cols-2 lg1024:gap-[9px] lg1024:px-[15px] lg1024:!mt-[4px] lg1024:!pb-[0px] lg1024:!mb-[20px]
                    "
                    >
                        {(latestVideos || []).map((item: any, index: any) => (
                            <a key={index} target="blank">
                                <Item
                                    item={item}
                                    isLast={false}
                                    type={"isVideoDetail"}
                                ></Item>
                            </a>
                        ))}
                    </div>
                </div>
                {/* <div className={styles["videos"]}>
                    <div className={styles["t"] + " lg1024:px-[15px]"}>
                        <p className="lg1024:!text-[16px]">{t("Similar")}</p>
                        <a
                            onClick={() => {
                                goLogin();
                            }}
                            className="lg1024:hidden"
                        >
                            {t("more")}
                        </a>
                    </div>
                    <div className="mt-[24px] itemBox grid grid-cols-5 gap-[30px] mt-[30px] pb-[78px] lg1024:grid-cols-2 lg1024:gap-[9px] lg1024:px-[15px] lg1024:!mt-[4px] lg1024:!pb-[20px]">
                        {(props.similarVideos || []).map(
                            (item: any, index: any) => (
                                <a key={index} target="blank">
                                    <Item
                                        item={item}
                                        isLast={false}
                                        type={"isVideoDetail"}
                                    ></Item>
                                </a>
                            )
                        )}
                    </div>
                    <div
                        className={
                            styles["t"] +
                            " lg1024:px-[15px] lg1024:!justify-center"
                        }
                    >
                        <a
                            onClick={() => {
                                goLogin();
                            }}
                            className="minlg1024:hidden"
                        >
                            {t("more")}
                        </a>
                    </div>
                </div>
                <div className={styles["videos"] + " lg1024:!mt-[20px]"}>
                    <div className={styles["t"]}>
                        <p className="lg1024:px-[15px] lg1024:!text-[16px]">
                            {t("More")}
                        </p>
                        <a
                            onClick={() => {
                                goLogin();
                            }}
                            className="lg1024:hidden"
                        >
                            {t("more")}
                        </a>
                    </div>
                    <div className="mt-[24px] itemBox grid grid-cols-5 gap-[30px] mt-[30px] pb-[78px] lg1024:grid-cols-2 lg1024:gap-[9px] lg1024:px-[15px] lg1024:!mt-[4px] lg1024:!pb-[20px]">
                        {(props.moreVideos || []).map(
                            (item: any, index: any) => (
                                <a key={index} target="blank">
                                    <Item
                                        item={item}
                                        isLast={false}
                                        type={"isVideoDetail"}
                                    ></Item>
                                </a>
                            )
                        )}
                    </div>
                    <div
                        className={
                            styles["t"] +
                            " lg1024:px-[15px] lg1024:!justify-center"
                        }
                    >
                        <a
                            onClick={() => {
                                goLogin();
                            }}
                            className="minlg1024:hidden"
                        >
                            {t("more")}
                        </a>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default GspPage;

type CustomGetServerSideProps<
    P extends { [key: string]: any } = { [key: string]: any },
    Q extends ParsedUrlQuery = ParsedUrlQuery
> = (
    context: GetServerSidePropsContext<Q>
) => Promise<GetServerSidePropsResult<P>>;

type GetServerSidePropsContext<Q extends ParsedUrlQuery = ParsedUrlQuery> = {
    res: ServerResponse;
    params?: Q;
    query: ParsedUrlQuery;
    preview?: boolean;
    resolvedUrl: string;
    locale: string;
    locales?: string[];
    defaultLocale?: string;
};

export const getServerSideProps: CustomGetServerSideProps = async (context) => {
    const { params, locale } = context;
    let str = params?.slug as string;
    str = str.replace(/[^0-9]/gi, "") as string;

    const res = await fetch.get(
        `${BaseUrl}/api/v1/seo/video/overview/${str}`,
        context
    );
    // console.log(res);
    const res1 = await fetch.get(
        `${BaseUrl}/api/v1/seo/video/moreSimilar/${str}`,
        ""
    );
    console.log(`${BaseUrl}/api/v1/seo/video/moreSimilar/${str}`);
    const version = await fetch.get(
        `${BaseUrl}/api/v1/rank/versions?rank_type=VIDEO_LIKE_RISING&rank_cycle=H24`,
        context
    );

    const res2 = await fetch.get(
        `${BaseUrl}/api/v1/rank/video_like_rising_rank?cycle=H24&version=${version?.data[0]?.version}&cursor=0&mobile_size=3`,
        context
    );

    return {
        props: {
            videoDetail: res.data || { latestVideos: [] },
            similarVideos: res1.data.similarVideos || [],
            moreVideos: res1.data.moreVideos || [],
            rankList: res2.data || [],
            ...(await serverSideTranslations(locale as string, [
                "influlist",
                "report",
                "nav",
                "footer",
            ])),
        },
    };
};
